export const headerHeight = 100;
export const footerHeight = 100;

